import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { Helmet } from "react-helmet";

import * as QueryString from 'query-string';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useHistory } from 'react-router-dom';
import PasswordIconText from 'web/assets/svg/PasswordIconText';
import EndIcon from 'web/assets/svg/PasswordShowIcon';
import TextInput from 'web/components/form-elements/TextInput';
import Button from 'web/components/Button';
import Spinner from 'web/components/Spinner';
import { IconInputField } from 'web/styles/Global';
import ForgotPassword from 'web/components/ForgotPassword';
import AlertModal from 'web/components/AlertModal';
import AcknowledgeModal from 'web/components/AcknowledgeModal';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import BrandLogo from 'web/assets/images/NewHeaderLogo.png';
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";
import Account from 'web/components/Account';
import FormContainer from 'web/components/FormContainer';
import { auth, accountActivation, getBetaUsersList, storeCardExpiryDetails } from 'redux/actions/auth';
import {
  getAuthInitialValues,
  VALIDATION_SCHEMA,
} from 'web/components/utils/authUtils';
import styles from './auth.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';
import ReCAPTCHA from "react-google-recaptcha";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const excludeCaptcha = ["DEVELOPMENT", "QA"]; // Add envoironmant here to Exclude Captha from page.

const Auth = ({ match, location }) => {
  const currentEnvoironmant = process.env.REACT_APP_ENV;
  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [languageValue, setLanguageValue] = useState('')
  const [pageLanguageContents, setPageLanguageContents] = useState()

  const [rememberMeObj, setRememberMeObj] = useState({
    email: '',
    password: '',
    isChecked: false,
  });
  let history = useHistory();

  const [response, setResponse] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [acknowledgeModalModal, setAcknowledgeModalModal] = useState(false);
  const [acknowledgeModalContent, setAcknowledgeModalContent] = useState('');
  const [acknowledgeModalLink, setAcknowledgeModalLink] = useState('/');
  const toggleAcknowledgeModal = () => setAcknowledgeModalModal(!acknowledgeModalModal);
  const [captchaStatus, setCaptchaStatus] = useState(false)

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  const params = QueryString.parse(location.search);
  const fetchMyAPI = useCallback(async () => {
    if (params.token !== undefined) {
      const response = await dispatch(accountActivation(params.token));
      if (response.success) {
        setRememberMeObj({ ...rememberMeObj, email: response.email })
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      } else {
        setRememberMeObj({ ...rememberMeObj, email: response.errorDetail.email });
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    } else {
      if (storedData?.rememberMe === 'true' || storedData?.rememberMe) {
        setRememberMeObj({
          ...rememberMeObj,
          email: localStorage.getItem('email'),
          isChecked: localStorage.getItem('checkbox')
        })
      } else {
        setRememberMeObj({
          email: '',
          password: '',
          isChecked: false,
        })
      }
    }
  }, []);

  const [tooltipOpenOne, setTooltipOpenOne] = useState(false);
  const iIcon = () => {
    return <>
      <img
        id="TooltipOne"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
          cursor: 'pointer',
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipOpenOne}
        target="TooltipOne"
        toggle={() =>
          setTooltipOpenOne(!tooltipOpenOne)
        }
      >
        <span style={{ 'Display': 'block', fontSize: '14px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>Password must have:</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least 8 characters.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one capital letter.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one lowercase letter.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one special characters.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one number</span>
      </Tooltip>
    </>
  }

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('disableFlg', false);
    fetchMyAPI();
  }, [fetchMyAPI]);

  const storedData = useSelector(
    (state) => state.storedData.payload
  );

  useEffect(() => {
    setLanguageValue(currentLanguage)
    dispatch(fetchLanguageContentNew(currentLanguage))
  }, [currentLanguage]);

  useEffect(() => {
    if (languageContentNew?.SignIn_Page) setPageLanguageContents(languageContentNew.SignIn_Page)
  }, [languageContentNew])

  const userRole = ((role) => {
    // userRole == BUYER, SELLER, BUYSELL, BROKER, GUEST
    if (role === "BUYER") {
      return "Buyer"
    } else if (role === "SELLER") {
      return "Seller"
    } else if (role === "BUYSELL") {
      return "Both"
    } else if (role === "BROKER") {
      return "Reseller"
    } else if (role === "GUEST") {
      return "Guest"
    } else if (role === "USER_GUEST") {
      return "Guest"
    }

  })

  const recaptchaRef = useRef();
  const onRecaptchaChange = () => {
    const recaptchaValue = recaptchaRef.current.getValue();

    if (!recaptchaValue || recaptchaValue === "") {
      setCaptchaStatus(false); // Set captchaStatus to false when expired
    } else {
      setCaptchaStatus(true); // Set captchaStatus to true when reCAPTCHA is valid
    }
  };

  const disableCaptcha = () => {
    setCaptchaStatus(true);
  }

  // captcha 
  const showCaptcha = useMemo(() => {
    const captchaEnabled = !excludeCaptcha.includes(currentEnvoironmant);
    if (!captchaEnabled) disableCaptcha();
    return captchaEnabled;
  }, [currentEnvoironmant, captchaStatus])

  const signInHandler = async (props) => {
    if (!captchaStatus) return
    let data = {
      email: props.values.email,
      password: props.values.password,
      rememberMe: props.values.rememberMe,
      captcha: showCaptcha ? recaptchaRef.current.getValue() : true
    };
    const response = await dispatch(auth(data));
    setResponse(response)
    if (response.success) {
      // localStorage.setItem('disableFlg', true)

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'successful_signin', });

      localStorage.setItem('currentLocalization', currentLanguage)
      if (props.values.rememberMe) {
        if (!localStorage.getItem('saveUrl'))
          localStorage.clear();

        localStorage.setItem('currentLocalization', currentLanguage)
        localStorage.email = props.values.email
        localStorage.checkbox = props.values.rememberMe
      } else {
        //localStorage.checkbox = props.values.rememberMe
        localStorage.email = props.values.email
      }

      dispatch(storeCardExpiryDetails(response?.data?.buyerCardExpired, response?.data?.sellerCardExpired, response?.data?.subscriptionCardExpired))
      localStorage.setItem('token', response?.data?.token);
      localStorage.setItem('locationID', response?.data?.locationId);
      localStorage.setItem('userId', response?.data?.userId);
      localStorage.setItem('state', response.data?.state)

      const expirationTime = new Date().getTime() + 9 * 60 * 1000;
      localStorage.setItem('ptTokenExpiration', expirationTime);

      let guestUser = false
      if (response.data?.userRole === "GUEST" || response.data?.userRole === 'USER_GUEST') {
        guestUser = true
        localStorage.setItem('disableFlg', true);
      } else {
        localStorage.setItem('disableFlg', false);
      }

      let brokerAccount = ''
      if (response?.data?.userRole === "BROKER") {
        brokerAccount = 'brokerAc'
        localStorage.setItem('brokerAccount', 'brokerAc');
      } else {
        brokerAccount = ''
        localStorage.setItem('brokerAccount', '');
      }
      // userRole == BUYER, SELLER, BUYSELL, BROKER, GUEST
      localStorage.setItem('accountType', userRole(response.data?.userRole));
      localStorage.setItem('refreshToken', response.data?.refreshToken);
      localStorage.setItem('authId', response?.data?.authId);
      localStorage.setItem('userName', response?.data?.userName)
      localStorage.setItem('companyName', response?.data?.locationName)
      localStorage.setItem('approvalStatus', response?.data?.approvalStatus);
      localStorage.setItem('miles', response?.data?.miles);

      let obj = {
        rememberMe: props.values.rememberMe,
        email: props.values.email,
        token: response?.data?.token,
        guestUser: guestUser,
        brokerAccount: brokerAccount,
        accountType: userRole(response.data?.userRole),
        refreshToken: response.data?.refreshToken,
        data: response?.data,
        authId: response?.data?.authId,
        userName: response?.data?.userName,
        locationID: response?.data?.locationId,
      }
      dispatch({ type: 'LOCAL_STORE_DATA', payload: obj })

      // dispatch(getBetaUsersList())
      localStorage.setItem('location', response?.data?.role[0])
      localStorage.setItem('locationId', response?.data?.locationId)

      if (response?.data?.userRole === "ADMIN") {
        localStorage.setItem('adminRolesData', response?.data?.role)
        localStorage.setItem('adminName', response?.data?.userName)
        localStorage.setItem('adminEmail', response?.data?.email)
        localStorage.setItem('adminAuthId', response?.data?.authId)
        localStorage.setItem('accountType', 'Admin');
        //dispatch(storeAdminDetails(response?.data?.role, response.adminInfo))
        if (response?.data?.role.includes('DASHBOARD_ADMIN') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/admin');
        else if (response?.data?.role.includes('USER_MANAGEMENT') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/users');
        else if (response?.data?.role.includes('USERACTIVITY_ADMIN') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/user-activity');
        else if (response?.data?.role.includes('USER_REPORTS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/reports');
        else if (response?.data?.role.includes('POSTS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/admin-posts');
        else if (response?.data?.role.includes('POST_VISIBILITY') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/admin-post-module');
        else if (response?.data?.role.includes('RESOLUTION_CENTER_ADMIN') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/claim');
        else if (response?.data?.role.includes('SUBSCRIPTION_ADMIN') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/subscription');
        else if (response?.data?.role.includes('CONTENT_MODERATION_ADMIN') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/content-moderation');
        else if (response?.data?.role.includes('PROMO_CODE') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/promo-code');
        else if (response?.data?.role.includes('REFERRAL_CODE') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/referral-code');
        else if (response?.data?.role.includes('APPLICATION_NON_USERS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/app-non-user');
        else if (response?.data?.role.includes('LANGUAGE_LOCALIZATION') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/language-localization');
        else if (response?.data?.role.includes('LOCATION_MANAGEMENT') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/location-management');
        else if (response?.data?.role.includes('NEW_INVITATIONS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/new-invitations');
        else if (response?.data?.role.includes('RETRY_ORDERS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/retry-orders');
        else if (response?.data?.role.includes('CANCEL_ORDERS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/cancel-orders');
        else if (response?.data?.role.includes('QUOTES') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/quotes');
        else if (response?.data?.role.includes('TERMS_AND_CONDITIONS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/terms-and-conditions');
        else if (response?.data?.role.includes('CHAT') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/chat-block');
        else if (response?.data?.role.includes('ORDER_CHAT') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/chats-order');
        else if (response?.data?.role.includes('PT_PLUS') || response?.data?.role.includes('SUPER_ADMIN')) history.push('/ptplus-user-managememt');

      } else if (response.paymentSetUpData) {
      } else {
        if (!response?.data?.acknowledged || !response?.data?.latestTermsAndCondition) {
          setAcknowledgeModalContent('');
          setAcknowledgeModalLink('');
          toggleAcknowledgeModal();
          localStorage.setItem('isTnCAcknowledged', response?.data?.acknowledged)
        } else {
          history.push('/dashboard');
        }
      }

    } else {
      let indexVal = null
      if (pageLanguageContents?.Backend_Popups) {
        pageLanguageContents.Backend_Popups.forEach((val, index) => {
          if (Object.keys(val)[0] === response.message) {
            indexVal = index
          }
        })
      }
      if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message])
      else setModalContent(response.message);
      setModalLink('');
      toggleModal();
    }
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setCaptchaStatus(false)
    }
  };
  const signUp = () => {
    localStorage.setItem('guestUser', false);
    localStorage.setItem('postInventory', false);
    localStorage.setItem('memberShipType', '');
  };

  const formFields = () => {
    return (
      <div className={styles.wrapper}>
        <img src={BrandLogo} alt='logo' style={{ marginBottom: 25, maxWidth: '255px', cursor: 'pointer' }} onClick={() => {
          history.push('/')
        }} />
        <div className={styles.body}>
          <Formik
            initialValues={getAuthInitialValues(rememberMeObj)}
            validationSchema={VALIDATION_SCHEMA(pageLanguageContents)}
            onSubmit={(values) => { }}
          >
            {(props) => {
              const { isValid, dirty, setFieldValue } = props;
              return (
                <>
                  <Form className={styles.form}>
                    <div className={styles.innerSection}>
                      <div>
                        <h3 className="mb-3">{pageLanguageContents?.SignIn[0]['Title']}</h3>
                        <div>
                          <p className={styles.inputLabel}>
                            {pageLanguageContents?.SignIn[1]['Email']}<span className="star">*</span>
                          </p>
                          <TextInput
                            name="email"
                            placeholder='Email'//{pageLanguageContents?.SignIn[2]['Email_Placeholder']}
                            maxLength={100}
                            showErrorMessages={true}
                          />
                        </div>
                        <div>
                          <p className={styles.inputLabel}>
                            {pageLanguageContents?.SignIn[4]['Password']}<span className="star">*</span>
                            {iIcon()}
                          </p>
                          <IconInputField>
                            <TextInput
                              name="password"
                              type={showPassword ? 'text' : 'password'}
                              placeholder={"Password (At least 8 characters)"}
                            />
                            {!showPassword ? (
                              <EndIcon
                                className='passwordIcon'
                                onClick={() => {
                                  setShowPassword(!showPassword);
                                }}
                              />
                            ) : (
                              <PasswordIconText
                                className='passwordIcon'
                                onClick={() => {
                                  setShowPassword(!showPassword);
                                }}
                              />
                            )}


                          </IconInputField>
                        </div>
                        <div className={styles.rememberSection}>
                          <CheckboxInput
                            name="rememberMe"
                            label={pageLanguageContents?.SignIn[7]['Remeber_Checkbox']}
                            handleSelect={(e) => { }}
                          />
                          <ForgotPassword buttonName={pageLanguageContents?.SignIn[8]['Forgot_Popup']} />
                        </div>
                        {showCaptcha && (
                          <div className='mb-3'>
                            <ReCAPTCHA
                              ref={recaptchaRef}
                              sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
                              onChange={onRecaptchaChange}
                            />
                          </div>
                        )}
                        <div className={styles.footer}>
                          {rememberMeObj.isChecked ? (
                            <Button
                              type="app-green-button submitBtn"
                              handleClick={() => {
                                signInHandler(props);
                              }}
                              disabled={!(isValid && captchaStatus)}
                            >
                              {pageLanguageContents?.SignIn[9]['Signin_Button']}
                            </Button>
                          ) : (
                            <Button
                              type="app-green-button submitBtn"
                              handleClick={() => {
                                signInHandler(props);
                              }}
                              disabled={!(isValid && dirty && captchaStatus)}
                            >
                              {pageLanguageContents?.SignIn[9]['Signin_Button']}
                            </Button>
                          )}
                        </div>
                        <div className={styles.fieldGroup}>
                          <div className={styles.field}></div>
                          <div className={styles.registerBox}>
                            <span> {pageLanguageContents?.SignIn[10]['Footer']}</span>
                            <Link
                              to="/registration"
                              onClick={signUp}
                            >
                              {pageLanguageContents?.SignIn[11]['Footer_register']}
                            </Link>
                            {/* <Link to="/registration">
                              {pageLanguageContents?.SignIn[11]['Footer_register']}
                            </Link> */}
                          </div>
                        </div>
                      </div>
                    </div>

                  </Form>
                </>
              );
            }}
          </Formik>

          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
          />
          {acknowledgeModalModal && <AcknowledgeModal
            isOpen={acknowledgeModalModal}
            toggle={toggleAcknowledgeModal}
            content={acknowledgeModalContent}
            link={acknowledgeModalLink}
            acknowledgeCallBack={() => {
              if (response.userInfo === null) {
              } else if (response.paymentSetUpData) {
                history.push('/credit-card');
              } else {
                history.push('/dashboard');
                // if (response.isDalanceyApproved) {                  
                // } else {
                //   history.push('/delancey-approval');
                // }
              }
            }}
          />}
        </div>
      </div>
    );
  }
  return (
    <Account>
      <Helmet title="PalletTrader | Sign In to Your PalletTrader Account">
        <meta name="description"
          content="Access your PalletTrader account to buy or sell pallets online. Sign in to manage your listings, track orders, and streamline your pallet operations." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/sign-in" />
      </Helmet>
      <FormContainer>
        {loaderVisible && <Spinner />}
        <div className={styles.signIn}>
          {rememberMeObj.email !== '' && params.token !== undefined &&
            formFields("")
          }
          {rememberMeObj.email === '' && params.token === undefined &&
            formFields()
          }
          {rememberMeObj.email !== '' && params.token === undefined &&
            formFields()
          }
        </div>
      </FormContainer>
    </Account>
  );
};

export default Auth;
